import { type DeliveryMethod } from '../../api/schema';

export const DELIVERY_METHODS: { [K in DeliveryMethod]: K } = {
    SELF_PICK_UP: 'SELF_PICK_UP',
    PICKUP_POINT: 'PICKUP_POINT',
    COURIER: 'COURIER',
};
